/**
 * Content / UI languages used by Routellers.
 */
export enum Languages {
    EN = 'en',
    DE = 'de',
    RU = 'ru',
    ES = 'es',
    PL = 'pl',
    FR = 'fr',
    IT = 'it',
}
